<template>
  <div>
    <!-- 地点A、Bアイコン表示 -->
    <l-marker
      :lat-lng="getPointALocation"
      :icon="pointA"
      :zIndexOffset="700"
      :options="options"
    ></l-marker>
    <l-marker
      :lat-lng="getPointBLocation"
      :icon="pointB"
      :zIndexOffset="700"
      :options="options"
    ></l-marker>
    <!-- 横断線AB表示 -->
    <l-polyline
      :lat-lngs="getLineABLocation"
      :color="colorlineAB"
      :weight="mapConfig.onMapLineAB.weight"
      :opacity="mapConfig.onMapLineAB.opacity"
      pane="surfacePane"
    ></l-polyline>
    <!-- 横断線P表示 -->
    <l-polyline
      v-if="getSurfaceConf.dispP === 1 || getSurfaceConf.dispP === 2"
      :lat-lngs="getLinePLocation"
      :color="colorlineP"
      :weight="mapConfig.onMapLineP.weight"
      :opacity="mapConfig.onMapLineP.opacity"
      pane="surfacePane"
    ></l-polyline>
  </div>
</template>

<script>
import { LMarker, LPolyline } from "vue2-leaflet";
import Marker from "../../../lib/markerSetting.js";
import Color from "../../../scss/color.scss";

/**
 * 川の防災情報 地図画面 横断図レイヤー
 * SurfaceLayer.vue
 * @author LIS
 */
export default {
  name: "surface-layer",
  components: {
    LMarker,
    LPolyline,
  },
  /** データ部 */
  data() {
    return {
      pointA: null,
      pointB: null,
      colorlineAB: Color.mapLineAB,
      colorlineP: Color.mapLineP,
      // マーカーオプション(タブ遷移の抑止)
      options: {
        keyboard: false,
      },
    };
  },
  mounted() {
    // 地点Aアイコン設定
    this.pointA = Marker.getIconObj(
      "pointA",
      this.mapConfig.markerSetting.crs.size
    );
    // 地点Bアイコン設定
    this.pointB = Marker.getIconObj(
      "pointB",
      this.mapConfig.markerSetting.crs.size
    );
  },
  /** 算出部 */
  computed: {
    /** 地図設定情報 */
    mapConfig: {
      get() {
        return this.$store.state.map.mapConfig;
      },
    },
    /** 設定情報 */
    config: {
      get() {
        return this.$store.state.app.config;
      },
    },
    /** 横断設定情報取得 */
    getSurfaceConf: {
      get() {
        if (this.$route.query["itmkndCd"] == 4) {
          return this.$store.state.Telemeter.surfaceConf;
        }
        return this.$store.state.Swin.surfaceConf;
      },
    },
    /** 地点Aの座標取得 */
    getPointALocation: {
      get() {
        return this.getSurfaceConf.locationA;
      },
    },
    /** 地点Bの座標取得 */
    getPointBLocation: {
      get() {
        return this.getSurfaceConf.locationB;
      },
    },
    /** 横断線ABの座標取得 */
    getLineABLocation: {
      get() {
        return [this.getPointALocation, this.getPointBLocation];
      },
    },
    /** 横断線Pの座標取得 */
    getLinePLocation: {
      get() {
        if (this.getSurfaceConf.dispP === 1) {
          return [
            /** 地点Aから横断線Pを描画する */
            this.getPointALocation,
            this.getSurfaceConf.locationP,
          ];
        } else if (this.getSurfaceConf.dispP === 2) {
          return [
            /** 地点Bから横断線Pを描画する */
            this.getPointBLocation,
            this.getSurfaceConf.locationP,
          ];
        } else {
          return [];
        }
      },
    },
  },
};
</script>
